import { Link } from "react-router-dom";

interface CounsellingCardProps {
  imageSrc: string;
  title: string;
  description: string;
  buttonText: string;
  linkTo: string;
}

const CounsellingCard = ({
  imageSrc,
  title,
  description,
  buttonText,
  linkTo,
}: CounsellingCardProps) => {
  return (
    <div className="group flex flex-col overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-card transition-all duration-300 hover:-translate-y-2 hover:shadow-soft">
      <div className="relative h-56 overflow-hidden">
        <img
          src={imageSrc}
          alt={title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-950/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      </div>
      <div className="flex flex-1 flex-col p-7">
        <h3 className="font-display text-2xl font-semibold text-slate-900">
          {title}
        </h3>
        <p className="mt-3 flex-1 leading-relaxed text-slate-600">
          {description}
        </p>
        <Link to={linkTo} className="mt-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-50 px-6 py-3 text-xs font-bold tracking-widest text-brand-700 transition-all duration-300 group-hover:bg-brand-700 group-hover:text-white">
            {buttonText}
            <svg
              className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default CounsellingCard;
